import { PageWithAsideLayout } from '@/components/client-layouts/page-with-aside-layout';
import NonMobileAside from '@/components/trade/non-mobile-aside';
import NonMobileHeader from '@/components/trade/non-mobile-header';
import NonMobileMain from '@/components/trade/non-mobile-main';
import TradeMobileMain from '@/components/trade/trade-in-mobile-main';
import LayoutBox1024 from '@/components/ui/layout/layout-1024-box';
import { tradeStore } from '@/models/stores/trades';
import { createFileRoute } from '@tanstack/react-router';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { observer } from 'mobx-react-lite';

export const Route = createFileRoute('/(authenticated)/trade/$shortId/')({
  component: TradeInAppraisalPageWrapper,
});

dayjs.extend(relativeTime);

// const MOCK_TRADE_IN_APPRAISAL: TradeInAppraisal = {
//   id: '10ce47e0-1345-1620-158e-18d63e654a2f',
//   short_id: 'TIA-1',
//   created_at: '2025-06-27T12:00:00Z',
//   updated_at: '2025-06-27T12:00:00Z',
//   deleted_at: null,

//   // Author of the appraisal
//   created_by_id: '004fcff4-90ed-41fb-bbf7-f1e6728f0d2b',

//   // Optional relationship to deal in case of linking to a deal
//   // deal_id: null,
//   deal_id: '00988684-8d69-4ca2-878b-0ee4f748b4a9',

//   // Trade in workflow
//   status: 'requested',

//   // Customer details
//   full_name: 'John Doe',

//   // Vehicle details
//   vin: 'JNKBV61F38M242316',
//   make: 'Toyota',
//   model: 'Camry',
//   trim: 'XLE',
//   year: 2024,
//   mileage: 152248,
//   condition: 'excellent',
//   number_of_keys: 2,
//   exterior_color: 'red',
//   interior_color: 'black',

//   // Ownership details
//   title_present: true,
//   lienholder: 'Mission Fed Credit Union',
//   payoff_amount: 1246732,

//   // Location
//   ever_location: 'SFO',
//   state: 'CA',
//   postal_code: '94101',

//   // How to mark for resale
//   resell_type: 'retail',

//   // Appraisal details
//   appraised_value: 1832743,
// };

export const TradePage = observer(() => {
  const { shortId } = Route.useParams();

  const trade = tradeStore.getByShortId(shortId);
  // const trade = toJS(tradeProxy);

  console.log('TradePage trade', trade);

  if (!trade) {
    return <div>Trade not found</div>;
  }

  return (
    <div className="h-full">
      <PageWithAsideLayout
        key={`deal-page-${trade?.id}`}
        mobile={{
          header: (
            // <MobileHeader
            //   id={shortId as string}
            //   tradeShortId={trade.short_id}
            // />
            <></>
          ),
          subheader: <div></div>,
          aside: <div>Aside (NOT YET IMPLEMENTED)</div>,
          main: <TradeMobileMain trade={trade} />,
        }}
        nonMobile={{
          header: <NonMobileHeader tradeShortId={trade.short_id} />,
          aside: <NonMobileAside trade={trade} />,
          main: (
            <LayoutBox1024>
              <NonMobileMain trade={trade} />
            </LayoutBox1024>
          ),
        }}
      />
    </div>
  );
});

export function TradeInAppraisalPageWrapper() {
  return <TradePage />;
}
